/* Delad rotator for barerna i sidhuvudet.
 *
 * Annonsbaren och rea-baren vaxlade var sitt innehall med samma algoritm skriven
 * tva ganger: init-vakt, hoppa av vid farre an tva, respektera reduced-motion,
 * setInterval som flyttar en aktiv-klass. Enda skillnaderna var klassnamnen och
 * takten. Bada ligger nu har, som attribut.
 *
 * Ytan behaller sitt eget tempo: annonsbaren 5000 ms, rea-baren 4000 ms. Olika
 * innehallslangd motiverar olika takt, sa de ar inte normaliserade.
 *
 *   <div data-on-rotator
 *        data-rotator-active="is-active"      klass som markerar aktivt (standard is-active)
 *        data-rotator-item=".on-bar__slot"    valfri barnselektor (standard: direkta barn)
 *        data-rotator-interval="4000">        ms (standard 5000)
 */
(function () {
  var DEFAULT_INTERVAL = 5000;

  function init(root) {
    if (!root || root.dataset.rotatorReady === '1') return;
    root.dataset.rotatorReady = '1';

    var sel = root.getAttribute('data-rotator-item');
    var items = sel ? root.querySelectorAll(sel) : root.children;
    var cls = root.getAttribute('data-rotator-active') || 'is-active';
    var ms = parseInt(root.getAttribute('data-rotator-interval'), 10);
    if (!ms || ms < 200) ms = DEFAULT_INTERVAL;

    if (!items.length) return;
    /* Ett enda innehall ska sta kvar synligt, inte vaxla mot sig sjalvt. */
    if (items.length < 2) { items[0].classList.add(cls); return; }

    var active = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains(cls)) { active = i; break; }
    }
    if (active === -1) { active = 0; items[0].classList.add(cls); }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    setInterval(function () {
      items[active].classList.remove(cls);
      active = (active + 1) % items.length;
      items[active].classList.add(cls);
    }, ms);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-on-rotator]').forEach(init);
  }

  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
